import { Outlet } from 'react-router';
import ErrorBoundary from '../../components/ErrorBoundary';
import SamlContainer from './SamlContainer';

const SamlWrapper = () => {
  return (
    <ErrorBoundary>
      <SamlContainer>
        <Outlet />
      </SamlContainer>
    </ErrorBoundary>
  );
};

export default SamlWrapper;
